__turbopack_context__.v({
  "controls": "CanvasEmbed-module__CWOLJW__controls",
  "frame": "CanvasEmbed-module__CWOLJW__frame",
  "root": "CanvasEmbed-module__CWOLJW__root",
});
